import { NavLink } from "react-router-dom";

const SiteAdminAppList = ({ auth }: Record<string, any>) => {
    return (
        <div className="list-group">
            <div className="list-group-item list-group-item-action bg-light">Application List</div>
            {auth.pro && (
                <NavLink className="list-group-item list-group-item-action" to="/abbvie-pro">
                    Abbvie Pro
                </NavLink>
            )}
            {auth?.lmbc && (
                <NavLink
                    className="list-group-item list-group-item-action"
                    to="/abbvie-lmbc/derm-finder"
                >
                    Abbvie LMBC
                </NavLink>
            )}
        </div>
    );
};

export default SiteAdminAppList;
